module.exports = "<div class=\"tip-notification clearfix\">\n  <div class=\"tip-notification-icon\">\n    <img src=\"" + require("../../assets/images/tip_icon.png") + "\">\n  </div>\n  <div class=\"tip-notification-message\" ng-transclude>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/tipNotification/template.html
// module id = 1234
// module chunks = 0